import apiClient from '@disco/api/server'
import { getEnvName } from '@disco/constants/environment'
import { Button } from 'components/ds'
import React, { useState } from 'react'
import StaffOnly from 'components/ui/staff-only'
import styles from 'components/ui/staff-only/index.module.css'
import cn from 'clsx'
import { pushUINotification } from '@disco/utils/notifications'

const SubscriptionAdmin = () => {
  const env = getEnvName()
  if (env == 'prod') return null
  return (
    <StaffOnly>
      <Button
        className={cn(styles.StaffOnlyBars)}
        color="orange"
        size="1"
        variant="solid"
        onClick={async () => {
          if (
            window.confirm('Reset business to Trial and unlink subscription?')
          ) {
            await apiClient.patchUrl(
              `${apiClient.host}/api/business_internal/current/`,
              {
                subscription_id: null,
                chargebee_subscription_id: null,
                plan_type: 'trial',
                plans: [{ external_id: 'trial', type: 'core' }],
              },
              '',
            )
            pushUINotification({
              message: `Business has been reset to trial`,
              level: 'success',
            })
          }
        }}
      >
        Reset business to Trial
      </Button>
    </StaffOnly>
  )
}

export default SubscriptionAdmin
